export const formatNumberAsGerman = (val) => {
  const num = Number(val);
  if (!Number.isFinite(num)) return "";

  const rounded = Math.round(num);

  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatGermanInputForDecimal = (value, showZero = false) => {

  if(showZero === true && value == ""){
    return "0"
  }

  if (value === null || value === undefined || value == "") return "";

  if (Number.isNaN(value)) return "";

  // if (Number(value) == 0) {
  //   return showZero ? "0,0" : "";
  // };

  if (
    value === Infinity ||
    value === -Infinity ||
    value === "Infinity" ||
    value === "-Infinity"
  ) {
    return "";
  }

  //  handle number type
  if (typeof value === "number") {
    // remove trailing .00
    if (Number.isInteger(value)) {
      return value.toLocaleString("de-DE");
    }

    return value.toLocaleString("de-DE");
  }

  // string logic (typing phase)
  const normalized = value.replace(".", ",");

  const [intPart, decimalPart] = normalized.split(",");

  const formattedInt =
    intPart !== "" ? Number(intPart).toLocaleString("de-DE") : "";

  if (normalized.includes(",")) {
    return decimalPart !== undefined
      ? `${formattedInt},${decimalPart}`
      : `${formattedInt},`;
  }

  return formattedInt;
};

export const formatGermanFixedBy2 = (
  value,
  minimumFractionDigits = 1,
  maximumFractionDigits = minimumFractionDigits,
  showZero = false
) => {
  if (value === null || value === undefined || value === "") return "";

  if (Number.isNaN(value)) return "";

  if (
    value === Infinity ||
    value === -Infinity ||
    value === "Infinity" ||
    value === "-Infinity"
  ) {
    return "";
  }

  // User is typing -> don't force formatting yet
  if (typeof value === "string") {
    return formatGermanInputForDecimal(value);
  }

  // if (Number(value) == 0) {
  //   return showZero ? "0,0" : "";
  // };

  return Number(value).toLocaleString("de-DE", {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};
